import script from "./ToppingsManuPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ToppingsManuPage.vue?vue&type=script&setup=true&lang=js"

import "./ToppingsManuPage.vue?vue&type=style&index=0&id=2aca9d0b&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/sakai-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2aca9d0b"]])

export default __exports__